import { find } from 'lodash';
import { EXPERIENCE_CATEGORIES, EXPERIENCE_THEMES } from '../constants/options';
import { formatPhoneNumber, parsePhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input';
import { DEFAULT_COUNTRY_INFO } from 'constants/options';

export const formatFirestoreDoc = docs => {
  const data = [];
  docs.forEach(doc => data.push(doc.data()));
  return data;
};

// Get doc data and merge doc.id
export const getDocData = doc => {
  return doc.exists === true ? { id: doc.id, ...doc.data() } : null;
};

// Get array of doc data from collection
export const getCollectionData = collection => {
  return collection.docs.map(getDocData);
};

/**
 * Return formatted number and country code
 * usecase: setting country_code and number in phoneNumberInput component
 * @param {string} phoneNumber
 * @return {{number: string, country_code: string}} number and country_code
 */
export const getFormattedPhoneNumber = phoneNumber => {
  const parsedNumber = parsePhoneNumber(phoneNumber);
  //For invalid number
  if (!parsedNumber) {
    return {
      number: phoneNumber,
      country_code: 'US',
    };
  }

  return {
    number: formatPhoneNumber(phoneNumber),
    country_code: parsedNumber.country,
  };
};

/**
 * For US number format to local
 * For International number format to internation value
 * @param {string} phoneNumber
 */
export const getintlFormattedNumber = phoneNumber => {
  const parsedNumber = parsePhoneNumber(phoneNumber);
  //For invalid number
  if (!parsedNumber) {
    return phoneNumber;
  }
  //For US number, format as local number
  // e.g. +12568748745 -> (256) 874-8745
  if (parsedNumber.country === 'US') {
    return formatPhoneNumber(phoneNumber);
  }
  //For International, format as international phone number
  //e.g. +9779812344950 -> +977 98 12344950
  return formatPhoneNumberIntl(phoneNumber);
};

export const formatEventInfo = (document, INITIAL_VALUES) => {
  const field = Object.keys(INITIAL_VALUES);
  const eventInfo = {};
  field.forEach(key => {
    switch (key) {
      case 'country': {
        if (!document['country']) {
          eventInfo['country'] = DEFAULT_COUNTRY_INFO.name;
          eventInfo['countryCode'] = DEFAULT_COUNTRY_INFO.countryCode;
        }
        break;
      }
      case 'startDate':
      case 'endDate':
      case 'duration': {
        eventInfo[key] = document[key] || 0;
        break;
      }
      default:
        eventInfo[key] = document[key];
    }
  });

  return eventInfo;
};

export const formatEventDocument = document => {
  const eventInfo = {
    hostedBy: document.hostedBy,
    category: document.category,
    theme: document.theme,
    id: document.id,
    owner: document.details.owner,
    ownerName: document.details.ownerName,
    title: document.title,
    shortDescription: document.shortDescription,
    longDescription: document.longDescription,
    promotionMedia: document.promotionMedia,
    promotionType: document.bannerImage ? 'photo' : 'video',
    bannerImage: document.bannerImage,
    duration: document.duration || '',
    startDate: document.details.startDate || 0,
    endDate: document.details.endDate || 0,
    restrictedValues: document.restrictedValues || [{}],
    includePopUpMap: document.includePopUpMap || 'yes',
    includeTipJar: document.includeTipJar || 'yes',
    elapsedTimeBonus: document.elapsedTimeBonus,
    type: document.details.type,
    status: document.details.status,
    pricing: document.details.pricing || 0,
    order: document.order || [],
    createdAt: document.createdAt,
    objectiveCount: document.objectiveCount,
    //Address
    state: document.address.state,
    city: document.address.city,
    country: document.address.country,
    countryCode: document.address.countryCode,
    street: document.address.street,
    streetNumber: document.address.streetNumber,
    zipCode: document.address.zipCode,
    latitude: document.address.latitude,
    longitude: document.address.longitude,
    fullAddress: document.address.fullAddress,
    isDeleted: document.isDeleted || false,
    isSuspended: document.isSuspended || false,
    deletedAt: document.deletedAt,
    deletedBy: document.deletedBy,
    updatedAt: document.updatedAt,
    pendingDate: document.pendingDate,
    multiPromo: document.multiPromo,
  };
  return eventInfo;
};

export const formatToEventDocument = values => {
  const eventDocument = {
    hostedBy: values.hostedBy,
    theme: values.theme,
    id: values.id,
    title: values.title,
    shortDescription: values.shortDescription,
    longDescription: values.longDescription,
    promotionMedia: values.promotionMedia,
    bannerImage: values.bannerImage,
    includePopUpMap: values.includePopUpMap || 'no',
    includeTipJar: values.includeTipJar || 'yes',
    elapsedTimeBonus: values.elapsedTimeBonus || 'yes',
    duration: values.duration || 0,
    restrictedValues: values.restrictedValues || [],
    details: {
      owner: values.owner,
      titleLowerCase: values.title.toLowerCase(),
      startDate: values.startDate,
      endDate: values.endDate,
      pricing: parseFloat(values.pricing || '0', 10),
      ownerName: values.ownerName,
      ownerNameLowerCase: values.ownerName.toLowerCase(),
      status: values.status,
      type: values.type,
    },
    address: {
      city: values.city || values.country,
      state: values.state,
      country: values.country,
      countryCode: values.countryCode,
      street: values.street || '',
      streetNumber: values.streetNumber || '',
      zipCode: values.zipCode || 0,
      latitude: values.latitude,
      longitude: values.longitude,
      fullAddress: values.fullAddress,
    },
  };
  return eventDocument;
};

export const categoriesType = type => {
  let data = find(EXPERIENCE_CATEGORIES, ['value', type]);
  return data?.label || '---';
};

export const themesType = type => {
  let data = find(EXPERIENCE_THEMES, ['value', type]);
  return data?.label || 'Miscellaneous';
};
